module.exports = __webpack_public_path__ + "img/compentation_experience_green.1fca1d0b.svg";